//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let titleFontSize = '5rem';
	//#endregion

	//#region seting vars based off params
	if (isMobile) {
		titleFontSize = '2rem';
	}
	//#endregion

	return {
		outerStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				width: `100%`,
				height: `auto`,
				marginTop: `3rem`,
			};
		},
		titleStyle: () => {
			return {
				width: `100%`,
				padding: `0rem ${minimumMarginX}rem 3rem ${minimumMarginX}rem`,
				color: 'black',
				textAlign: 'center',
				fontSize: titleFontSize,
			};
		},
	};
}

export default Styles;
